import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import RadioControl from './RadioControl';
import Label from '../../forms/Label';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'RadioGroup');
function RadioGroup(_ref) {
  let {
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    onBlur,
    label,
    hint,
    isFullWidth,
    labelMode = 'horizontal',
    orientation = 'vertical',
    onChange = () => {},
    value = null,
    options = [],
    isReadOnly = false
  } = _ref;
  const classes = useClasses(useStyles, classesProp);
  // Overrides
  const override = getOverrides(overridesProp, RadioGroup.overrides);

  // Classes
  const rootClassName = classnames(classes.root, {
    [classes.isReadOnly]: isReadOnly,
    [classes[`${labelMode}Label`]]: labelMode,
    [classes[orientation]]: orientation
  }, classNameProp);
  const formControlClassName = classnames(classes.formControl, {
    [classes.isFullWidth]: isFullWidth
  });
  const rootProps = {
    className: rootClassName
  };
  const labelProps = {
    className: classes.Label,
    hint,
    ...override.Label
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), label && /*#__PURE__*/React.createElement(Label, labelProps, label), /*#__PURE__*/React.createElement("div", _extends({
    className: formControlClassName
  }, override.formControl), options.map(option => /*#__PURE__*/React.createElement(RadioControl, {
    key: option.value,
    onClick: isReadOnly ? undefined : onChange,
    overrides: overridesProp,
    isReadOnly: isReadOnly,
    option: option,
    value: value,
    onChange: onChange,
    onBlur: onBlur,
    classes: classesProp,
    className: classes.radioControl
  }))));
}
RadioGroup.overrides = ['root', 'Radio', 'formControl', 'Label'];
process.env.NODE_ENV !== "production" ? RadioGroup.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  value: PropTypes.any,
  label: PropTypes.string,
  labelMode: PropTypes.oneOf(['horizontal', 'vertical']),
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Info popover */
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isReadOnly: PropTypes.bool,
  isFullWidth: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(RadioGroup);